import update from 'immutability-helper';
import {
    SET_PARTNER_SIGNUP_STATUS,
    SET_PARTNER_SIGNUP_IS_LOADING,
    SET_PARTNER_SIGNUP_EMAIL_SENT,
} from './actions';

const initialState = {
    status: null,
    errorCode: null,
    isLoading: false,
    emailSent: false,
};

export default function partnerSignupReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PARTNER_SIGNUP_STATUS:
            return update(state, {
                status: { $set: action.status },
                errorCode: { $set: action.errorCode },
            });
        case SET_PARTNER_SIGNUP_IS_LOADING:
            return update(state, {
                isLoading: { $set: action.isLoading },
            });
        case SET_PARTNER_SIGNUP_EMAIL_SENT:
            return update(state, {
                emailSent: { $set: action.emailSent },
            });
        default:
            return state;
    }
}
